export const packageTypes = [
  {
    id: 0,
    title: "none",
  },
  {
    id: 1,
    title: "Main",
  },
  {
    id: 2,
    title: "Custom",
  },
];
